import Vue from  'vue';

import mixin from '../../core/core-video-player'

export default {

    mixins: [mixin],

    props: {
        src: {type: String, default: null}
    },

}
